import * as React from 'react';
import { compose, withProps, onlyUpdateForKeys, setDisplayName, withState } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { withClassname } from '@components/hoc/withClassname';
import { DogsForm } from '@modules/dogs/DogsForm';

import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import DogsActionBar from '@modules/dogs/DogsActionBar';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const dogsUrl = '/metropolis/api/dg/dogs';
export const dogsLabel = 'Psi';
export const dogsPath = '/dogs';
export const dogsGridName = 'DogsGrid';
export const DogsGrid = compose(
  withRouter,
  setDisplayName(dogsGridName),
  withState('url', 'setUrl', dogsUrl),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: dogsLabel }]),
  withColumns(Agenda.DOGS),
  withProps(({ url, columns }) => {
    const {
      config: {
        extensions: { doglust }
      }
    } = getConfigurationContext();
    return {
      name: dogsGridName,
      url,
      Form: DogsForm,
      dialog: false,
      gridProps: {
        columns,
        ActionBar: ({ refresh, state }) => (
          <>
            <ColumnManager agenda={Agenda.DOGS} />
            <div style={{ marginLeft: 5 }}>
              <DogsActionBar doglust={doglust} refresh={refresh} state={state} />
            </div>
          </>
        ),
        filterRow: true,
        showCheckboxes: true,
        deleting: true,
        filtering: true,
        locale: 'cz',
        adding: true,
        pageSize: 50,
        version: 9,
        sort: 'created'
      }
    };
  }),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsGrid.tsx